module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hydroware-container"
  }, [_c('div', {
    staticClass: "col-xs-12 hydroware-container-heading"
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._t("header_title", [(_vm.title !== null) ? _c('div', {
    staticStyle: {
      "font-size": "2em"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.title) + "\n            ")]) : _vm._e()])], 2), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._t("after_header_title")], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 hydroware-container-body"
  }, [_vm._t("body")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d81b3f8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/widgets/hydroware-container-with-heading.vue
// module id = 779
// module chunks = 1